import styled from '@emotion/styled';
import { Divider, Table, TableCell, TableRow, TextField } from '@mui/material';

export const styles = (theme) => ({
  root: {
    width: '100%',
    position: 'relative',
  },
  headerdiv: {
    paddingLeft: '15%',
    paddingTop: '10',
  },
  hidden: {
    display: 'none',
  },
});

export const StyledTable = styled(Table)(({ theme }) => ({
  minWidth: 1020,
}));

export const StyledTableWrapper = styled('div')(({ theme }) => ({
  overflowX: 'auto',
}));

export const StyledSpinner = styled('div')(({ theme }) => ({
  position: 'absolute',
  background: 'rgba(255,255,255,.4)',
  width: '100%',
  height: '100%',
  zIndex: '9999',
  left: 0,
  top: 0,
}));

export const StyledSpinnerImage = styled('img')(({ theme }) => ({
  top: 'calc(50% - 32.5px)',
  left: 'calc(50% - 65px)',
  position: 'absolute',
  width: '130px',
  userSelect: 'none',
}));

export const StyledTCellHead = styled(TableCell)(({ theme }) => ({
  padding: '10px',
  color: 'rgba(0, 0, 0, 0.54)',
}));

export const StyledTCellBody = styled(TableCell)(({ theme }) => ({
  padding: '10px',
}));

export const StyledTRowBody = styled(TableRow)(({ theme }) => ({
  height: '50px',
}));

export const StyledDivider = styled(Divider)(({ theme }) => ({
  marginTop: '10px',
  height: '5px',
}));

export const StyledTextField = styled(TextField)(({ theme }) => ({
  margin: theme.spacing.unit,
  minWidth: 120,
  maxWidth: 390,
}));



// WEBPACK FOOTER //
// ./src/components/reports/kiosk-box-utilization/styledComponents.js